const DriverIcon = ({ ...props }) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.2 3.6C3.2 2.27452 4.27452 1.2 5.6 1.2C6.92548 1.2 8 2.27452 8 3.6C8 4.92548 6.92548 6 5.6 6C4.27452 6 3.2 4.92548 3.2 3.6ZM5.6 0C3.61177 0 2 1.61177 2 3.6C2 5.58822 3.61177 7.2 5.6 7.2C7.58822 7.2 9.2 5.58822 9.2 3.6C9.2 1.61177 7.58822 0 5.6 0ZM3.1 9C2.26488 9 1.47244 9.35422 0.894511 9.97068C0.317808 10.5858 0 11.4123 0 12.2667V13.6C0 13.9314 0.268629 14.2 0.6 14.2C0.931371 14.2 1.2 13.9314 1.2 13.6V12.2667C1.2 11.7065 1.40898 11.1765 1.76996 10.7914C2.12971 10.4077 2.60904 10.2 3.1 10.2H8.1C8.59096 10.2 9.07029 10.4077 9.43005 10.7914C9.79102 11.1765 10 11.7065 10 12.2667V13.6C10 13.9314 10.2686 14.2 10.6 14.2C10.9314 14.2 11.2 13.9314 11.2 13.6V12.2667C11.2 11.4123 10.8822 10.5858 10.3055 9.97068C9.72756 9.35422 8.93513 9 8.1 9H3.1Z"
        fill="#353D48"
      />
      <path
        d="M6.37612 11.4624L8.05943 8.73908L9.98437 8.00111L14.0024 12.0453L9.52229 16.6201L6.37612 11.4624Z"
        fill="white"
      />
      <circle cx="12" cy="12" r="3.5" stroke="#353D48" />
      <path d="M15.5 11C15.5 11 13.2349 12 12 12C10.7651 12 8.5 11 8.5 11" stroke="#353D48" />
      <path d="M12 12L12 15" stroke="#353D48" />
    </svg>
  );
};

export default DriverIcon;
